export default "__VITE_ASSET__DPYYX0iR__"